import Control from 'ol/control/Control'

import { setMeasure, hideMeasure } from '../map/measure'
import { OPERATION } from '../handlers'

// Measure area button
export class AreaControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    if (options.id) button.id = options.id;
    button.title = 'Mål areal';
    button.innerHTML = '<i class="material-icons">square_foot</i>';
    button.innerHTML = '<i class="material-icons">signal_cellular_null</i>';

    const element = document.createElement('div');
    element.className = 'measure-area ol-unselectable ol-control';
    element.appendChild(button);
    if (options.position) element.style.bottom = options.position + 'px';

    super({ element: element, target: options.target });

    button.addEventListener('click', this.toggleMeasure.bind(this));
  }

  toggleMeasure = () => {
    const control = document.querySelector('.measure-area');
    control.classList.toggle('active');
    const active = control.classList.contains('active');
    if (!active) hideMeasure();
    const info = document.querySelector('.lift')?.id === 'toolbar_info';
    if (['add', 'edit'].indexOf(OPERATION) > -1 || info) {
      control.classList.remove('active');
    } else {
      document.querySelector('.measure-length').classList.remove('active');
      setMeasure(active);
    }
  };
}

